import {
  IFillDataWizardDealService,
  TBooleanKeysOfIFillDataWizardDealService,
  TKeyOfDataWizardDealService,
  TStringKeysOfIFillDataWizardDealService,
} from "../..";
import { ESideDeal } from "../../../../../../shared/wizard/steps/types";
import StepDealService_1 from "../step_1";
import StepDealService_2 from "../step_2";
import StepDealService_3 from "../step_3";
import StepDealService_4 from "../step_4";
import StepDealService_5 from "../step_5";
import StepDealService_6 from "../step_6";

const getDealServiceSteps = (
  data: IFillDataWizardDealService,
  dataFormEstimate: Partial<IFillDataWizardDealService>,
  dataFeatures: Partial<IFillDataWizardDealService>,
  onReset: (keys: TKeyOfDataWizardDealService[], data?: number[]) => void,
  handleChangeDataString: (
    data: ESideDeal,
    key: TStringKeysOfIFillDataWizardDealService
  ) => void,
  handleChangeDataBoolean: (
    data: boolean,
    key: TBooleanKeysOfIFillDataWizardDealService
  ) => void,
  handleChangeDataObject: (data: Partial<IFillDataWizardDealService>) => void,
  disabledAndPrev: {
    isNextStep_sideDeal: boolean;
    isNextStep_estimate: boolean;
    isNextStep_dataFeatures: boolean;
    isNextStep_isAllParticipantDealInCity: boolean;
  }
) => {
  const {
    isNextStep_sideDeal,
    isNextStep_estimate,
    isNextStep_dataFeatures,
    isNextStep_isAllParticipantDealInCity,
  } = disabledAndPrev;

  return [
    <StepDealService_1 />,
    <StepDealService_2
      onChange={handleChangeDataString}
      data={data.sideDeal}
      onReset={onReset}
      isNextStepDisabled={isNextStep_sideDeal}
    />,
    <StepDealService_3
      onChange={handleChangeDataBoolean}
      data={data.isAllParticipantDealInCity}
      isNextStepDisabled={isNextStep_isAllParticipantDealInCity}
      onReset={onReset}
    />,
    <StepDealService_4
      onChange={handleChangeDataObject}
      data={dataFeatures}
      onReset={onReset}
      isNextStepDisabled={isNextStep_dataFeatures}
    />,
    <StepDealService_5
      onChange={handleChangeDataObject}
      dataFormEstimate={dataFormEstimate}
      onReset={onReset}
      isNextStepDisabled={isNextStep_estimate}
    />,
    <StepDealService_6 data={data} />,
  ];
};

export default getDealServiceSteps;
